import React from 'react';
import { ShieldCheckIcon, WrenchIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { OFFER_ANCHOR, PRODUCT_IMG } from './constants';
export function Hero() {
  return <section className="bg-brand-carbon px-4 pb-5 pt-5 text-white" data-id="element-77" data-mp="9kjuoj1ugu11">
      <div className="mx-auto max-w-3xl text-center" data-id="element-78" data-mp="9ip7ey33opts">
        <h1 className="mb-2 font-display text-[26px] leading-[1.02] text-white sm:text-5xl" data-id="element-79" data-mp="4mrt0xbedtjn">
          The Complete <span className="text-brand-yellow" data-id="element-80" data-mp="12860zz2gicrl">Visual Fault-Finding System</span> for
          Diesel Technicians
        </h1>
        <p className="mx-auto mb-3 max-w-2xl text-[13px] font-medium leading-snug text-brand-line sm:text-base" data-id="element-81" data-mp="xb5w3rhcfg22">
          Stop diagnosing diesel problems from scratch. Use ready-to-use diagnostic workflows,
          testing guides and fault-finding tools to move from symptoms and trouble codes to a
          clearer diagnostic path.{' '}
          <span className="font-bold text-white" data-id="element-82" data-mp="381xn73sg3cct">
            Find the fault. Follow the tests. Diagnose with confidence.
          </span>
        </p>

        <a href={OFFER_ANCHOR} className="mb-3 block cursor-pointer" aria-label="Go to the offer" data-id="element-83" data-mp="3j9agpbwlmo4m">
          <img src={PRODUCT_IMG} alt="Diesel Diagnostic Pro complete 6-in-1 system box set" className="mx-auto w-full max-w-[320px] object-contain drop-shadow-2xl transition-transform duration-150 ease-out hover:scale-[1.02] sm:max-w-md" data-id="element-84" data-mp="3o6u5v6uu4lbc" />
        </a>

        <CTAButton className="mx-auto mb-2 max-w-md" data-id="element-85" data-mp="30hhsrvwdzt3r">
          🔧 YES! I WANT THE COMPLETE SYSTEM
        </CTAButton>

        <p className="mb-1.5 font-cond text-sm font-bold uppercase tracking-wide text-brand-yellow sm:text-base" data-id="element-86" data-mp="359j9pv4i2804">
          Get DIESEL DIAGNOSTIC PRO™ Today
        </p>
        <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-[11px] font-semibold uppercase tracking-wide text-brand-line sm:text-xs" data-id="element-87" data-mp="2viev4wiqkp5t">
          <span className="flex items-center gap-1" data-id="element-88" data-mp="2hl9rf36hw2dq">
            <ShieldCheckIcon aria-hidden="true" className="h-4 w-4 text-brand-yellow" data-id="element-89" data-mp="2ll0i76w0uii9" />
            🛡️ 7-Day Money-Back Guarantee
          </span>
          <span className="flex items-center gap-1" data-id="element-90" data-mp="s44i1nkpdlhw">
            <WrenchIcon aria-hidden="true" className="h-4 w-4 text-brand-yellow" data-id="element-91" data-mp="naa0aponrglg" />
            🔧 Complete 6-in-1 System
          </span>
        </div>
      </div>
    </section>;
}